export default {
    methods: {
        formatTime(timeString) {
            if (!timeString || !timeString.includes(':')) return '00:00';

            const [hours, minutes] = timeString.split(':').map(Number);
            const formattedHours = hours.toString().padStart(2, '0');
            const formattedMinutes = minutes.toString().padStart(2, '0');

            return `${formattedHours}:${formattedMinutes}`;
        },

        timeToMinutes(timeString) {
            if (!timeString || !timeString.includes(':')) return 0;
            const [hours, minutes] = timeString.split(':').map(Number);
            return hours * 60 + minutes;
        },

        calculateDuration(startTime, endTime) {
            const startMinutes = this.timeToMinutes(startTime);
            const endMinutes = this.timeToMinutes(endTime);
            return Math.max(0, endMinutes - startMinutes);
        },

        hasOverlap(timeRanges, index) {
            if (index >= timeRanges.length - 1) return false;

            const currentEndTime = this.timeToMinutes(timeRanges[index].end_time);
            const nextStartTime = this.timeToMinutes(timeRanges[index + 1].start_time);

            return currentEndTime > nextStartTime;
        },

        hasOverlapInDay(timeRanges) {
            if (!timeRanges || timeRanges.length <= 1) return false;

            const sortedRanges = [...timeRanges].sort((a, b) =>
                this.timeToMinutes(a.start_time) - this.timeToMinutes(b.start_time)
            );

            for (let i = 0; i < sortedRanges.length - 1; i++) {
                const currentEndTime = this.timeToMinutes(sortedRanges[i].end_time);
                const nextStartTime = this.timeToMinutes(sortedRanges[i+1].start_time);
                if (currentEndTime > nextStartTime) {
                    return true;
                }
            }

            return false;
        },

        hasAnyDayOverlap() {
            if (!this.sortedTimeRanges) return false;

            for (const day in this.sortedTimeRanges) {
                if (this.hasOverlapInDay(this.sortedTimeRanges[day])) {
                    return true;
                }
            }
            return false;
        },

        hasPause(timeRanges, index) {
            if (index >= timeRanges.length - 1) return false;

            const currentEndTime = timeRanges[index].end_time;
            const nextStartTime = timeRanges[index + 1].start_time;

            return this.calculateDuration(currentEndTime, nextStartTime) > 0;
        },

        calculatePauseDuration(currentTimeRange, nextTimeRange) {
            return this.calculateDuration(currentTimeRange.end_time, nextTimeRange.start_time);
        },

        hasOpeningPause(timeRanges, openingHour) {
            if (!timeRanges || !timeRanges.length) return false;

            const firstAppointmentStart = timeRanges[0].start_time;

            return this.calculateDuration(openingHour, firstAppointmentStart) > 0;
        },

        calculateOpeningPauseDuration(openingHour, firstAppointmentStart) {
            return this.calculateDuration(openingHour, firstAppointmentStart);
        },

        hasClosingPause(timeRanges, closingHour) {
            if (!timeRanges || !timeRanges.length) return false;

            const lastAppointmentEnd = timeRanges[timeRanges.length - 1].end_time;

            return this.calculateDuration(lastAppointmentEnd, closingHour) > 0;
        },

        calculateClosingPauseDuration(lastAppointmentEnd, closingHour) {
            return this.calculateDuration(lastAppointmentEnd, closingHour);
        },

        sortTimeRanges(timeRanges) {
            if (!timeRanges || timeRanges.length === 0) {
                return {};
            }

            const groupedByDay = timeRanges.reduce((acc, timeRange) => {
                const day = timeRange.day;
                acc[day] = acc[day] || [];
                acc[day].push(timeRange);
                return acc;
            }, {});

            const sortedDays = Object.keys(groupedByDay).sort();
            const result = {};

            sortedDays.forEach(day => {
                result[day] = [...groupedByDay[day]].sort((a, b) => {
                    return this.timeToMinutes(a.start_time) - this.timeToMinutes(b.start_time);
                });
            });

            return result;
        }
    }
};
